import { useQuery } from "react-query";
import axios from "axios";

const getTimeTables = async (props) => {
  const platform_code = props.queryKey[0];

  // 本番
  const url = `https://firebasestorage.googleapis.com/v0/b/numazu-station-signage.appspot.com/o/json%2F${platform_code}_timetable.json?alt=media`;

  // STG
  // const url = `https://firebasestorage.googleapis.com/v0/b/numazu-station-signage-stg.appspot.com/o/json%2F${platform_code}_timetable.json?alt=media`;

  console.log(url)
  const { data } = await axios.get(url);

  console.log("getTimeTables " + props.queryKey[0]);
  console.log(data);
  return data;
};

export const useQueryTimeTables = (platformCode) => {
  return useQuery({
    queryKey: [platformCode, "timetables"],
    queryFn: getTimeTables,
    cacheTime: 36000000,
    staleTime: 36000000
  });
};
// 60000 => 1分
// 3600000 => 1時間
// 36000000 => 10時間
// 72000000 => 20時間
